import {useOutletContext, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import TableComment from "../components/TableComment";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {UsersService} from "../services/UsersService";
import {useSelector} from "react-redux";
import UserDropdownTemplate from "../templates/UserDropdownTemplate";
import UserDropdownValueTemplate from "../templates/UserDropdownValueTemplate";
import {classNames} from "primereact/utils";
import {ClientService} from "../services/ClientService";

export default function ClientComments() {

    const context = useOutletContext()
    const [comments, setComments] = useState(context.comments)
    const [users, setUsers] = useState([])
    const [addTaskDialogVisible, setAddTaskDialogVisible] = useState(false)
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const userData = useSelector(function (state) {
        return state.auth.userData
    });

    const taskFormik = useFormik({
        initialValues: {
            date: '',
            user_id: false,
            text: ''
        },
        validate: (data) => {
          let errors = {}
          if(!data.text){
              errors.text = 'Напишите комментарий!'
          }
          if(!data.date){
              errors.date = 'Укажите срок выполнения задачи!'
          }

          return errors
        },
        onSubmit: (data) => {

            ClientService.AddComment(context.id, userData.id, data.text, {
                user_id: data.user_id ? data.user_id : userData.id,
                from_user_id: data.user_id ? userData.id : null,
                date: data.date
            }).then((e) => {
                taskFormik.resetForm()
                setAddTaskDialogVisible(false)
                context.updateUser()
            })

        }
    })

    const commentFormik = useFormik({
        initialValues: {
            text: ''
        },
        validate: (data) => {
            let errors = {}
            if (!data.text) {
                errors.text = 'Необходимо написать комментарий!'
            }
            return errors
        },
        onSubmit: (data) => {
            ClientService.AddComment(context.id, userData.id, data.text).then((res) => {
                commentFormik.resetForm()
                context.updateUser()
            })
        }
    })


    const isCommentFormFieldInvalid = (name) => !!(commentFormik.touched[name] && commentFormik.errors[name]);

    const getCommentFormErrorMessage = (name) => {
        return isCommentFormFieldInvalid(name) ? <small className="p-error">{commentFormik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    const isTaskFormFieldInvalid = (name) => !!(taskFormik.touched[name] && taskFormik.errors[name]);

    const getTaskFormErrorMessage = (name) => {
        return isTaskFormFieldInvalid(name) ? <small className="p-error">{taskFormik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    useEffect(() => {
        if (currentDepartment) {
            UsersService.GetList({
                filter: {
                    user_type: 'worker',
                    status: 1,
                    departmentId: currentDepartment
                },
                fields: 'id,username,position.name,avatar',
                'per-page': 1000,
            }).then((result) => {
                setUsers(result.items)
            })
        }
    }, [currentDepartment]);

    useEffect(() => {
        setComments(context.comments)
    }, [context])

    return (
        <>
            <Dialog
                footer={<><Button type={'button'} className={'p-button-secondary p-button-outlined'} label={'Отмена'}
                                  onClick={(e) => setAddTaskDialogVisible(false)}/><Button
                    className={'p-button-success'} type={'submit'} form={'dialog-task-form'} label={'Добавить'}/></>}
                visible={addTaskDialogVisible} position={'right'} style={{width: '500px'}}
                onHide={(e) => setAddTaskDialogVisible(false)} header={'Добавить задачу'}>
                <form id={'dialog-task-form'} onSubmit={taskFormik.handleSubmit} className={'d-flex flex-column gap-3 m-t-15'}>
                    <FormGroup label={'Срок выполнения'}>
                        <Calendar showTime stepMinute={10} showButtonBar
                                  value={taskFormik.values.date}
                                  onChange={(e) => taskFormik.setFieldValue('date', e.value)}
                                  className={'w-100 ' + classNames({'p-invalid': isTaskFormFieldInvalid('date')})}/>
                        {getTaskFormErrorMessage('date')}
                    </FormGroup>

                    <FormGroup label={'Исполнитель'}>
                        <Dropdown filter placeholder={'Выберите сотрудника'} value={taskFormik.values.user_id}
                                  valueTemplate={UserDropdownValueTemplate}
                                  onChange={(e) => taskFormik.setFieldValue('user_id', e.target.value)}
                                  itemTemplate={UserDropdownTemplate} options={users.map((user) => {
                            return {
                                label: user.username,
                                value: user.id,
                                avatar: user.avatar,
                                position: user.position.name
                            }
                        })}   className={classNames({'p-invalid': isTaskFormFieldInvalid('user_id')})}/>
                        {getTaskFormErrorMessage('user_id')}
                    </FormGroup>

                    <FormGroup label={'Описание задачи'}>
                        <InputTextarea autoResize value={taskFormik.values.text} onChange={(e) => taskFormik.setFieldValue('text', e.target.value)} rows={5} placeholder={'Описание задачи'}  className={'w-100 ' + classNames({'p-invalid': isTaskFormFieldInvalid('text')})}/>
                        {getTaskFormErrorMessage('text')}
                    </FormGroup>
                </form>
            </Dialog>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between">
                        <h3 className={'m-b-0'}>Комментарии и задачи</h3>


                        <Button label={'Добавить задачу'} type={'button'} onClick={(e) => setAddTaskDialogVisible(true)}
                                className={'p-button-success p-button-outlined'} icon={'pi pi-plus'}/>
                    </div>
                </div>
                <div className="card-body">
                    <div className="comment-list d-flex flex-column gap-3 align-items-start">
                        {comments.map((comment) => {
                            return (
                                <TableComment model={comment}/>
                            )
                        })}

                        {!comments.length && <p className={'text-muted'}>Пока нет комментариев.</p>}
                    </div>

                </div>

                <div className="card-footer">
                    <form onSubmit={commentFormik.handleSubmit}>
                        <div className="d-flex input-group input-group-sm w-100 flex-nowrap">
                            <InputTextarea autoResize value={commentFormik.values.text}
                                           onChange={(e) => commentFormik.setFieldValue('text', e.target.value)} className={'w-100 ' + classNames({'p-invalid': isCommentFormFieldInvalid('text')})}/>
                            <Button type={'submit'} label={'Отправить'} className={'flex-shrink-0'}
                                    icon={'pi pi-send'}/>
                        </div>

                        {getCommentFormErrorMessage('text')}
                    </form>
                </div>
            </div>
        </>
    )
}